// Generated by CoffeeScript 1.10.0
(function() {
    'use strict';
    angular.module('booking.services', [])
        .factory('BOOKING', ['$window', function(win) {
            var booking = {
                name: '',
                email: '',
                mobile: '',
                address_1: '',
                address_2: '',
                location_id: null,
                city: '',
                repeat: 'once',
                postcode: '',
                state: '',
                hours_booked: '4',
                date: '',
                session: 'morning',
                job_type: 'basic',
                bedroom_count: 3,
                bathroom_count: 2,
                house_type: 'Apartment',
                house_size: 1800,
                payment_type: 'creditcard',
                order_total: 80,
                discount: 0,
                coupon_code: '',
                note: '',
                token: '',
                reqs: {
                    'fridge': false,
                    'oven': false,
                    'fan': false,
                    'ironing': false
                },
                prefer: {
                    previous: false,
                    female: false,
                    twocleaners: false
                },
                coordinate: '',
                coordinate_verified: 0,

                verification_code: '',
                displayDate: '',

                payment_status: 'unpaid',
                payment_method: 'creditcard',
                payment_method_nonce: '',
                pricing_model: 'normal',
                payment_amount: 'full', // deposit or full
                rayaSpecial : false,
                showCaptcha :false
            };

            var trans = {
                apartment: 'Apartment',
                semid: 'Semi-D',
                linkh: 'Link house',
                bungalow: 'Bungalow',
                once: 'One time only',
            };

            var pricing = {
                basic: {

                    normal :{
                        'once': 100,
                        'weekly': 320,
                        '2weekly': 150,
                        '4weekly': 75,
                        'evening': 50
                    },

                    nextday :{
                        'once': 100,
                        'weekly': 320,
                        '2weekly': 150,
                        '4weekly': 75,
                        'evening': 55
                    },

                    surge :{
                        'once': 100,
                        'weekly': 352,
                        '2weekly': 150,
                        '4weekly': 75
                    },

                    evening :{
                        'once': 50,
                        'weekly': 200,
                        '2weekly': 150,
                        '4weekly': 75
                    },

                },

                movein: {

                    normal : {
                        '1000': 260,
                        '1800': 380,
                        '2500': 500,
                        '3500': 760
                    },

                    surge : {
                        '1000': 260,
                        '1800': 380,
                        '2500': 500,
                        '3500': 760
                    },

                },

                 spring: {

                    normal : {
                        '1000': 300,
                        '1800': 540,
                        '2500': 750
                    },

                    surge : {
                        '1000': 300,
                        '1800': 540,
                        '2500': 750
                    },

                },

                carpet: {

                    normal : {
                        '30': 120,
                        '50': 150,
                        '70': 180
                    },

                    surge:{
                        '30': 120,
                        '50': 150,
                        '70': 180
                    }
                },

                painting: {

                }

            };

            var discounts = {
                basic: {

                    normal: {
                        'once': 0,
                        'weekly': 16,
                        '2weekly': 150,
                        '4weekly': 75,
                        'evening': 0
                    },

                    nextday: {
                        'once': 0,
                        'weekly': 16,
                        '2weekly': 150,
                        '4weekly': 75,
                        'evening': 0
                    },

                    surge: {
                        'once': 0,
                        'weekly': 16,
                        '2weekly': 150,
                        '4weekly': 75,
                        'evening': 0
                    }
                },

                movein: {

                    normal:{
                        '1000': 0,
                        '1800': 0,
                        '2500': 0,
                        '3500': 0
                    },

                    surge:{
                        '1000': 0,
                        '1800': 0,
                        '2500': 0,
                        '3500': 0
                    }
                },

                carpet: {

                    normal:{
                        '30': 0,
                        '50': 0,
                        '70': 0
                    },

                    surge:{
                        '30': 0,
                        '50': 0,
                        '70': 0
                    }
                },

                painting: {

                }
            };

            var deposit = {
                movein:{
                    '1000' : 52,
                    '1800' : 76,
                    '2500' : 100,
                    '3500' : 152

                },
                spring:{
                    '1000' : 60,
                    '1800' : 108,
                    '2500' : 150,
                    '3800' : 50

                }

            };

            var options = {
                enableDiscount: true
            };

            var user = {
                verified: false,
                auth: false,
                name: '',
                avatar: ''
            };

            return {
                getBooking: function() {
                    return booking;
                },

                getUser: function() {
                    return user;
                },

                trans: function(p) {
                    return trans[p];
                },

                // calculate the price
                getPrice: function() {

                    var  p = 0;
                    if (booking.token) {
                        p = booking.order_total;
                    } else {

                        var d = new Date( booking.displayDate);
                        var pricingModel = (d.getDay() == 6 || d.getDay() == 0) ? 'surge' : 'normal';

                        // console.log('Premium: '+ premiumPricing );

                        switch (booking.job_type) {
                            case 'basic':
                                if( booking.session != 'evening'){
                                    var tmr = new Date( Date.now() );
                                    tmr.setDate( tmr.getDate() + 1 );

                                    var tdy = new Date( Date.now() );
                                    var nextDay =( (  tmr.getDate() + '-' +tmr.getMonth() + '-'+ tmr.getYear())  ==  (d.getDate() + '-'  + d.getMonth()+ '-' + d.getYear())  );
                                    nextDay = nextDay || ( (  tdy.getDate() + '-' +tdy.getMonth() + '-'+ tdy.getYear())  ==  (d.getDate() + '-'  + d.getMonth()+ '-' + d.getYear())  );

                                    if(nextDay){
                                        // disable next-day pricing
                                        pricingModel = 'nextday';
                                    }

                                    p = pricing[booking.job_type][pricingModel][booking.repeat];
                                } else {
                                    p = pricing[booking.job_type]['evening'][booking.repeat];
                                }

                                if(booking.rayaSpecial){
                                    p = 200;
                                }else if(booking.schoolSpecial){
                                    p = 120;

                                    if(booking.kids > 2)
                                    {
                                        p = 120 + ((booking.kids-2) * 40);
                                    }
                                }
                                else if(booking.studioSpecial){
                                    p = 50;
                                }
                                break;
                            case 'movein':
                                p = pricing[booking.job_type][pricingModel][booking.house_size];
                                break;
                                
                            case 'spring':
                                p = pricing[booking.job_type][pricingModel][booking.house_size];
                                if(booking.bedroom_addon > 0){
                                    p = p + (booking.bedroom_addon * 60);
                                }if(booking.bathroom_addon > 0){
                                    p = p + (booking.bathroom_addon * 60);
                                }
                                break;    

                            case 'carpet':
                                p = pricing[booking.job_type][pricingModel][booking.house_size];
                                break;
                            case 'painting':
                                // each can price 200
                                if( booking.bathroom_count == 1){
                                    p = 200
                                } else {
                                    p = 200 + ((booking.bathroom_count -1) * 200);
                                }
                                break;

                            case 'airbnb':
                                p = 35;

                                if(booking.bedroom_count > 1)
                                    p += ((booking.bedroom_count - 1) * 15);
                                break;
  
                        }

                        booking.pricing_model = pricingModel;
                    }

                    if( booking.job_type == 'basic' && booking.session == 'fullday'){
                        p =  p*2;
                    }


                    console.log('price:' + p);

                    return p;
                },

                getDiscount: function( booking ) {
                    var  p = 0;

                    if ( booking.token) {
                        p = booking.discount;
                    } else {

                        var d = new Date( booking.displayDate);
                        var pricingModel = (d.getDay() == 6 || d.getDay() == 0) ? 'surge' : 'normal';

                        switch (booking.job_type) {
                            case 'basic':

                                if( booking.session != 'evening'){
                                    var tmr = new Date( Date.now() );
                                    tmr.setDate( tmr.getDate() + 1 );
                                    var nextDay =( (  tmr.getDate() + '-' +tmr.getMonth() + '-'+ tmr.getYear())  ==  (d.getDate() + '-'  + d.getMonth()+ '-' + d.getYear())  );
                                    if(nextDay){
                                        pricingModel = 'nextday';
                                    }
                                    p = discounts[booking.job_type][pricingModel][booking.repeat];
                                } else {
                                    // 2 hours, evening session
                                    p = '0';
                                }
                                break;
                            case 'movein':
                                p = discounts[booking.job_type][pricingModel][booking.house_size];
                                break;

                            case 'carpet':
                                p = discounts[booking.job_type][pricingModel][booking.house_size];
                                

                                break;
                        }

                        if( booking.job_type == 'basic' && booking.session == 'fullday')
                            p =  p*2;

                        if(booking.referral_code){
                            p  = p + 15;
                            console.log("total discounts + referral",p);
                        }   
                    }

                    

                    return p;
                },

                getDeposit :function(booking)
                {
                    var p = 0;
                    switch (booking.job_type) {
                        case 'movein':
                            p = deposit[booking.job_type][booking.house_size];
                            break;
                        case 'spring':
                            p = deposit[booking.job_type][booking.house_size];
                            break;    
                    }   
                    return p;
                },

                setOptions: function( opt ){
                    for (var attrname in opt) { options[attrname] = opt[attrname]; }
                },

                // 58.80 for first bookings
                setFirstTimeBooking: function() {
                    // console.log('Setting first time booking');
                    discounts.basic.normal.once = 0;
                    discounts.basic.surge.once = 0;
                    discounts.basic.normal.weekly = 0;

                },

            };

        }]);

}).call(this);

(function() {
    'use strict';
    angular.module('booking.controllers', ['booking.services','ngAutocomplete'])

    /******************************* Start Page Controller ***********************************************/
    .controller('startCtrl', [
        '$scope', '$rootScope', '$route', '$document', '$http', '$routeParams', '$location', '$timeout', 'BOOKING', '$anchorScroll',
        function($scope, $rootScope, $route, $document, $http, $routeParams, $location, $timeout, BOOKING , $anchorScroll) {
        angular.element(document).ready(function () {
            var $window;
            $window = $(window);

            $scope.booking = BOOKING.getBooking();
            $scope.user = BOOKING.getUser();
            $scope.booking.title = "";

            //for local testing
            //$scope.user.verified = true;
            
            $scope.referral = [];
    
            $scope.previousBooking = JSON.parse(localStorage.getItem('booking'));
            $scope.availableSession = null;
            // $scope.previousBooking = null;
            
            //get all cookies
            var getCookies = function(){
              var pairs = document.cookie.split("; ");
              var cookies = {};
              for (var i=0; i<pairs.length; i++){
                var pair = pairs[i].split("=");
                cookies[pair[0]] = unescape(pair[1]);
              }
              return cookies;
            }

            var cookies = getCookies();

            console.log("cookies",cookies.referrer_code);

            if(cookies.referrer_code != 'undefined' && cookies.referrer_code != undefined )
            {
                //check if referral exist or valid @todo
                $http.post('https://core.maideasy.my/api/v1/referrals/check',{"referral_code":cookies.referrer_code})
                // $http.post('http://localhost:8080/api/v1/referrals/check',{"referral_code":cookies.referrer_code})
                .success(function(response){
                    //set booking referral
                    $scope.booking.referral_code = cookies.referrer_code;
                    $scope.referrarName = response.user;
                    $scope.booking.discount = BOOKING.getDiscount( $scope.booking );
                })
                .error(function(data){
                    console.log("referral code not found");
                })
            }else{
                //clear cookies if found referral code undefined
                document.cookie = 'referrer_code=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            }

            

            // angular.clone/extend loses the object watch scope
            if ($scope.previousBooking) {
                console.log('previousBooking loaded');

                for (var key in $scope.booking) {
                    if (typeof $scope.previousBooking[key] !== 'undefined') {
                        $scope.booking[key] = $scope.previousBooking[key];
                    }
                }

                // reset certain fields
                $scope.booking.job_type = $routeParams.session;
                $scope.booking.city = '';
                $scope.booking.date = '';
                $scope.booking.token = '';
                $scope.booking.repeat = 'once';
                $scope.booking.hours_booked = '4';
                $scope.booking.session = 'morning';
                $scope.booking.time = '9:00AM';
                $scope.booking.bedroom_count = 3;
                $scope.booking.bathroom_count = 2;
                $scope.booking.house_type = 'Apartment';
                $scope.booking.house_size = 1800;
                $scope.booking.payment_type = 'creditcard';
                $scope.booking.order_total = 80;
                $scope.booking.discount = 0;
                $scope.booking.coupon_code = '';
                $scope.booking.note = '';
                $scope.booking.reqs = {
                    'fridge': false,
                    'oven': false,
                    'fan': false,
                    'ironing': false
                };
                $scope.booking.prefer = {
                    previous: false,
                    female: false,
                    twocleaners: false
                };
                $scope.booking.verification_code = '';
                $scope.booking.displayDate = '';
                $scope.booking.payment_status = 'unpaid';
                $scope.booking.payment_method = 'creditcard';
                $scope.booking.payment_method_nonce = '';
                $scope.booking.bedroom_addon = 0;
                $scope.booking.bathroom_addon = 0;

                if($scope.booking.name.indexOf(". ") != "-1")
                {
                    $scope.name = $scope.booking.name.split(". ");
                    $scope.booking.name = $scope.name[1]
                    $scope.booking.title = $scope.name[0]+".";
                }

                // There's no need to verify again
                $scope.user.verified = true;

                // Store the previous booking number
                $scope.previousMobile = $scope.booking.mobile;
            } else {
                // Set default location
                $scope.booking.job_type = $routeParams.session;
                //$scope.booking.location_id = 1;
                //$scope.booking.city = 'Bangsar';
                //$scope.booking.state = 'Kuala Lumpur';

                // Set default session
                $scope.booking.session = 'morning';
                $scope.booking.time = '9:00AM';
                $scope.booking.hours_booked = '4';
                $scope.booking.bedroom_addon = 0;
                $scope.booking.bathroom_addon = 0;

               // $scope.booking.repeat = $routeParams.package;
            }

            $scope.requests = 0;
            $scope.contactSubmitted = false;
            $scope.requiredCheckbox = {
                tnc: false,
                priority: false
            };
            $scope.locations = [];
            $scope.calendarHtml = 'Loading...';
            $scope.validationErrors = [];
            $scope.verificationMessage = null;

            $scope.map = false;
            $scope.initCity = false;
            $scope.initState = false;

            $scope.booking.rayaSpecial = false;

            $scope.datePlaceholder="Select date";

            $scope.isSameDay = false;

            $scope.times = [];

            //for local testing
            //$scope.booking.date = "2017-05-03";
            //$scope.booking.displayDate = "2017-05-03";

            for(var x = 0 ; x < 9 ; x++){

                var v = moment('2013-02-08 10:00:00.000').add(x,'hours').format('hh:mmA');
                var d = moment('2013-02-08 10:00:00.000').add(x,'hours').format('hh:mm A');

                $scope.times.push({value:v,name:d});
            }

            $scope.validate = function() {
                $scope.validationErrors = [];

                $timeout(function() {
                    angular.forEach(angular.element('.help-block'), function(element) {
                        if (!angular.element(element).hasClass('hidden')) {
                            $scope.validationErrors = $scope.validationErrors.concat(angular.element(element).text())
                        }
                    });
                }, 100);
            }

            // get current user
            $http({
                method: 'GET',
                url: '/api/user'
            }).then(function successCallback(response) {
                $scope.booking.address_1 = (response.data.address_1) ? response.data.address_1 : '';
                $scope.booking.address_2 = (response.data.address_2) ? response.data.address_2 : '';
                $scope.booking.location_id = (response.data.location_id) ? response.data.location_id : '';
                $scope.booking.state     = (response.data.state) ? response.data.state : '';

                // update location so that calendar load properly
                // $scope.updateLocation($scope.booking.location_id);
                
                $scope.booking.name = response.data.name;
                $scope.booking.email = response.data.email;
                $scope.booking.mobile = response.data.mobile;
                
                $scope.user.name = response.data.name;
                $scope.user.avatar = response.data.avatar;
                $scope.user.verified = true;
                $scope.user.auth = true;
            }, function errorCallback(response) {});

            // get the location list
            $http({
                method: 'GET',
                url: '/api/bookings/locations'
            }).then(function successCallback(response) {
                $scope.locations = response.data;
            }, function errorCallback(response) {});

            $scope.updateLocation = function(locationId) {
                var result = $.grep($scope.locations, function(location) {
                    return location.id == locationId;
                });
                var location = result[0];

                $scope.booking.city = location.city;
                $scope.booking.state = location.state;
            }

            $scope.updateSession = function() {
                console.log($scope.booking.session);

                switch ($scope.booking.session) {
                    case 'fullday':
                        $scope.booking.hours_booked = '8';
                        $scope.booking.time = "9:00AM";
                        $scope.booking.bedroom_count = 5;
                        $scope.booking.bathroom_count = 4;
                        
                        break;
                    case 'morning':
                        $scope.booking.hours_booked = '4';
                        $scope.booking.time = "9:00AM";
                        $scope.booking.bedroom_count = 3;
                        $scope.booking.bathroom_count = 2;
                        
                        break;
                    case 'afternoon':
                        $scope.booking.hours_booked = '4';
                        $scope.booking.time = "02:00PM";
                        $scope.booking.bedroom_count = 3;
                        $scope.booking.bathroom_count = 2;

                        break;
                    case 'evening':
                        $scope.booking.hours_booked = '2';
                        $scope.booking.time = "08:00PM";
                        $scope.booking.bedroom_count = 0;
                        $scope.booking.bathroom_count = 0;
                        
                        break;
                }

                console.log($scope.booking);
            }

            $scope.updateKids = function()
            {
                $scope.booking.order_total = BOOKING.getPrice();
            }

            $scope.updateMobile = function() {
                if ($scope.booking.mobile == $scope.previousMobile) {
                    $scope.user.verified = true;
                } else {
                    $scope.user.verified = false;
                }

                // always assume number is correct for logged-in user
                if( $scope.user.auth){
                    $scope.user.verified = true;
                }
            }

            // console.log(BOOKING);

            // track booking changes
            // $scope.$watch(BOOKING, function() {
            //  console.log(BOOKING);
            // }, true);


            // update map
            // $scope.$watch('booking.address_2', function() {
            //     // $scope.initMap();
            // }, true);

            // track city changes.
            $scope.$watch('[booking.city, booking.job_type, booking.house_size]', function() {
                // console.log('Calendar update');

                $scope.booking.date = '';
                $scope.booking.displayDate = '';
                $scope.booking.session = '';

                $scope.initMap();
                $scope.updateSession();
                if($routeParams.package == "evening")
                {
                    $scope.booking.session = 'evening';
                }
                console.log($scope.booking.date);
            }, true);

            // change in state
            $scope.$watch('booking.state', function() {
                // console.log('state changed');
                // $scope.loadCities();
            }, true);

            // change in date
            $scope.$watch('booking.displayDate', function() {
                // alert($scope.booking.displayDate);
                // If new date is on weekend, remove any discount
                // var d = Date( $scope.booking.displayDate);
                // if(d.getDay() == 6 || d.getDay() == 0) {
                //     $scope.booking.discount = 0;
                //     BOOKING.setOptions( { enableDiscount : false} );
                // };
                $scope.pricing = BOOKING.getPrice();
            }, true);

            // $scope.loadCities = function() {
            //     return;
            //     // get the location list
            //     $http({
            //         method: 'GET',
            //         url: '/api/bookings/locations/' + $scope.booking.state
            //     }).then(function successCallback(response) {
            //         // this callback will be called asynchronously
            //         // when the response is available
            //         $scope.locations = response.data;
            //         $scope.booking.city = $scope.locations[0];
            //     }, function errorCallback(response) {
            //         // called asynchronously if an error occurs
            //         // or server returns response with an error status.
            //     });
            // }

            // $scope.$watch(BOOKING.getBooking().city, function() {
            //  console.log('city changed');
            // }, true);

            // afterRender
            $scope.init = function(id) {
                // $('#booking-form').validator();

                $('#closedModal').modal({
                    backdrop: 'static'
                });
                // if android, show android app download link
                var userAgent = navigator.userAgent || navigator.vendor || window.opera;
                var is_android = false;
                if( userAgent.match( /iPad/i ) || userAgent.match( /iPhone/i ) || userAgent.match( /iPod/i ) )
                {
                //return 'iOS';

                }
                else if( userAgent.match( /Android/i ) )
                {

                    is_android = true;
                }
                // if(is_android){
                //     $('#androidModal').modal({
                //         backdrop: 'static'
                //     });
                // } else {

                //     var promo = sessionStorage.getItem('promo');

                //     if(!promo)
                //     {
                //         $('#stepModal').modal({
                //             backdrop: 'static'
                //         });

                //         $('#stepModal').on('shown.bs.modal', function (e) {
                //               // do something...
                //               sessionStorage.setItem("promo",'cimb');

                //         })
                //     }
                    

                    
                // }
            };
            // afterRender
            $scope.init2 = function(id) {
                // $('#booking-form-2').validator();
            };

            // select service
            $scope.selectService = function(jobType) {

                if( jobType == 'raya' ){
                    $scope.booking.job_type = 'basic';
                    $scope.booking.hours_booked = 8;
                    $scope.booking.session = 'morning';
                    $scope.booking.rayaSpecial = true;

                }else if(jobType == 'studio'){

                    $scope.booking.job_type = 'basic';
                    $scope.booking.hours_booked = 2;
                    $scope.booking.session = 'custom';
                    $scope.booking.studioSpecial = true;
                    $scope.booking.bedroom_count = 1;
                    $scope.booking.bathroom_count = 1;

                }
                else {
                    $scope.booking.session = 'morning';
                    $scope.booking.hours_booked = 4;
                    $scope.booking.bedroom_count = 3;
                    $scope.booking.bathroom_count = 2;
                    $scope.booking.studioSpecial = false;
                    $scope.booking.job_type = jobType;
                }

                // if carpet is selected, default 'house_size' to small
                if(jobType == 'carpet')
                    $scope.booking.house_size = 30;
                else
                    $scope.booking.house_size = 1800;

                // reset all discount after selecting new service
                $scope.booking.discount = 0;

                return;
            };

            // verify phone number
            $scope.verifyContactForm = function(isValid) {
                // var isValid = false;

                $('#closedModal').modal({
                    backdrop: 'static'
                });
                $scope.contactSubmitted = true;
                // only show modal if form id valid
                // $('#booking-form').
                $scope.verificationMessage = null;

                //for local skip sms
                // $('#verifyModal').modal({
                //             backdrop: 'static'
                //         });

                // return;

                // $http.post('/api/bookings/book/verify', $scope.booking)
                //     .success(function(data, status) {
                //         $('#verifyModal').modal({
                //             backdrop: 'static'
                //         });
                //     });

                // if (isValid) {
                    
                // }
                return;
            };

            // do actual verification
            $scope.verifyNow = function() {

                $http.post('/api/bookings/book/verifycode', $scope.booking)
                    .success(function(data, status) {

                        // console.log(data);

                        //call previous cleaner api
                        $scope.showPreviousCleaners($scope.booking.mobile);

                        //check referral
                        $scope.checkReferralUsed($scope.booking.mobile);


                        // all ok
                        if (data.success == 1) {
                            $scope.user.verified = true;
                            $scope.verificationMessage = null;

                            // A different price for first time bookings
                            if (data.firsttime == 1) {
                                BOOKING.setFirstTimeBooking();
                            }

                            // store user cookie
                            document.cookie = "user=" + data.userid + "; expires=Thu, 25 Dec 2020 12:00:00 UTC; path=/";

                            // navigator.geolocation.getCurrentPosition($scope.successLocationCallback);

                            // check to make sure the form is completely valid
                            $('#verifyModal').modal('hide');

                            // FB event
                            fbq('track', 'Lead', { 
                                content_type: 'product',
                                content_name: $scope.booking.job_type,
                                value: ($scope.booking.order_total * 0.3),
                                currency: 'MYR'
                            });

                        } else {
                            // not ok
                            $scope.verificationMessage = 'Verification code invalid. Please try again';
                            $scope.user.verified = false;
                        }
                    });

                return;
            };

            // reverify phone number
            $scope.verifyResend = function() {
                $http.post('/api/bookings/book/verify', $scope.booking)
                    .success(function(data, status) {
                        $scope.verificationMessage = 'Verification code resent to ' + $scope.booking.mobile;
                    });

                return;
            };

             $scope.showPreviousCleaners = function(phoneNumber)
            {
                //send phone number
                // $http.get('/customer/'+phoneNumber+'/cleaner')
                $scope.cleaners = [];

                $http.get('/customer/'+phoneNumber+'/cleaner').success(function(data, status) {
                    $scope.allCleaner = data;
                    var previous = "";

                    //filer duplicate cleaner    
                    angular.forEach($scope.allCleaner, function(value, key){
                       if(value.cleaner_id != previous)
                       {

                            if(value.cleaner_name.indexOf("-") != "-1")
                            {
                                value.cleaner_name=value.cleaner_name.split("-")[1];
                            };

                            $scope.cleaners.push (value);
                            previous = value.cleaner_id; 
                       }
                     });
                });
            };

            $scope.checkReferralUsed = function(phoneNumber){

                $scope.referral.referral_code = cookies.referrer_code;
                $scope.referral.mobile = phoneNumber;

                console.log("referral",cookies.referrer_code);

                if(cookies.referrer_code != 'undefined' && cookies.referrer_code != undefined)
                {
                    $http.post('https://core.maideasy.my/api/v1/referrals/used',{'referral_code':$scope.referral.referral_code,'mobile':$scope.referral.mobile})
                    //$http.post('http://localhost:8080/api/v1/referrals/used',{'referral_code':$scope.referral.referral_code,'mobile':$scope.referral.mobile})
                    .success(function(data){
                        if(data.success == 0)
                        {
                            $scope.referralError = true;
                            $scope.referralUsed = "Referral code already used";

                            //clear cookies if found referral code already used
                            document.cookie = 'referrer_code=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                            $scope.booking.referral_code = false;
                            $scope.booking.discount = BOOKING.getDiscount( $scope.booking );

                            console.log("check referral_code");

                        }
                        else if(data.success == 1)
                        {
                            $scope.referralSuccess = true;
                            $scope.referralUsed = "Enjoy RM 15 discount for your first booking";
                        }
                    })
                    .error(function(err){
                        console.log("error checkReferralUsed",err)
                    })

                }else{
                    //clear cookies if found referral code undefined
                    document.cookie = 'referrer_code=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                }

            }

            $scope.chooseCleaner = function(cleaner){
                console.log(cleaner.checked);
               cleaner.checked = !cleaner.checked;
           }
           $scope.selectCheckCleaner = function()
            {
                $scope.cleanersChecked = $scope.cleaners.filter(function(cleaners) {
                  return cleaners.checked;
                });
            };




            // verify phone number
            $scope.verifyBookingForm = function(isValid) {

                $('#closedModal').modal({
                    backdrop: 'static'
                });
                //$scope.bookingSubmitted = true;
                //$scope.validate();

                // only show modal if form id valid
                // $('#booking-form').
                // if (isValid) {
                //     // $('#verifyModal').modal({backdrop: 'static'});
                //     // console.log('bookingCompleted');
                //     $('#summaryModal').modal();
                //     return true;
                //     // return $scope.bookingCompleted();
                // } else {
                //     return false;
                // }
            };


            // select request
            $scope.toggleRequest = function(req) {

                console.log($scope.booking);
                if ($scope.booking.reqs[req] == false) {

                    if( $scope.requests == 2){
                        return;
                    }

                    $scope.booking.reqs[req] = true;
                    $scope.requests++;
                } else {
                    $scope.booking.reqs[req] = false;
                    $scope.requests--;
                }

                return;
            };

            // has requests
            $scope.hasRequests = function() {
                return $scope.requests > 0;
            }

            // has requests
            $scope.hasPreferences = function() {
                return $scope.requests > 0;
            }

            $scope.addBathroom = function() {
                $scope.booking.bathroom_count++;
            };
            $scope.subBathroom = function() {
                if ($scope.booking.bathroom_count > 0) {
                    $scope.booking.bathroom_count--;
                }
            };

            $scope.addCans = function() {
                $scope.booking.bathroom_count++;
            };
            $scope.subCans = function() {
                if ($scope.booking.bathroom_count > 1) {
                    $scope.booking.bathroom_count--;
                }
            };

            $scope.addBedroom = function() {
                $scope.booking.bedroom_count++;
            };
            $scope.subBedroom = function() {
                if ($scope.booking.bedroom_count > 0) {
                    $scope.booking.bedroom_count--;
                }
            };

            //add on
            $scope.addOnBedroom = function() {
                $scope.booking.bedroom_addon++;
                $scope.booking.bedroom_count += $scope.booking.bedroom_addon;
            };

            $scope.subOnBedroom = function() {
                if ($scope.booking.bedroom_addon > 0) {
                    $scope.booking.bedroom_addon--;
                    $scope.booking.bedroom_count--;
                }
            };

            $scope.addOnBathroom = function() {
                $scope.booking.bathroom_addon++;
                $scope.booking.bathroom_count += $scope.booking.bathroom_addon;
            };
            $scope.subOnBathroom = function() {
                if ($scope.booking.bathroom_addon > 0) {
                    $scope.booking.bathroom_addon--;
                    $scope.booking.bathroom_count--;
                }
            };

            // set repeat
            $scope.repeat = function(rep) {
                $scope.booking.repeat = rep;
                $scope.booking.discount = BOOKING.getDiscount( $scope.booking );
                console.log( $scope.booking.discount );

                if(rep == 'once'){
                    $scope.datePlaceholder = 'Select date';
                }

                if(rep == 'weekly'){
                    $scope.datePlaceholder = "Select first's session date";
                }

                return;
            };

            // set repeat
            $scope.houseSize = function(rep) {
                $scope.booking.house_size = rep;

                if($scope.booking.house_size < 2500) {
                    $scope.booking.session = 'morning';
                } else {
                    $scope.booking.session = 'fullday';
                }

                if($scope.booking.job_type == 'spring')
                {
                    $scope.houseType();
                }

                $scope.updateSession();

                return;
            };

            $scope.houseType = function()
            {
                if($scope.booking.house_size == 1000)
                {
                    $scope.booking.house_type = "Small Apartment / Studio";
                    $scope.booking.bedroom_count = 3;
                    $scope.booking.bathroom_count = 2;

                    //reset add on
                    $scope.booking.bedroom_addon = 0;
                    $scope.booking.bathroom_addon = 0;
                }
                else if($scope.booking.house_size == 1800)
                {
                    $scope.booking.house_type = "Apartment / Small House";
                    $scope.booking.bedroom_count = 4;
                    $scope.booking.bathroom_count = 3;

                    //reset add on
                    $scope.booking.bedroom_addon = 0;
                    $scope.booking.bathroom_addon = 0;
                }
                else if($scope.booking.house_size == 2500)
                {
                    $scope.booking.house_type = "Medium Size House";
                    $scope.booking.bedroom_count = 5;
                    $scope.booking.bathroom_count = 4;

                    //reset add on
                    $scope.booking.bedroom_addon = 0;
                    $scope.booking.bathroom_addon = 0;
                }
                else if($scope.booking.house_size == 3800)
                {
                    $scope.booking.house_type = "Larger Size House";
                    $scope.booking.bedroom_count = 5;
                    $scope.booking.bathroom_count = 4;

                    //reset add on
                    $scope.booking.bedroom_addon = 0;
                    $scope.booking.bathroom_addon = 0;
                }
            }

            // set carpet size
            $scope.carpetSize = function(rep) {
                $scope.booking.house_size = rep;
                return;
            };

            // open calendar modal, load actual calendar from system and re-compile them
            $scope.loadCalendar = function() {

                $scope.calendarHtml = 'Loading...';

                $http.post('/api/bookings/book/calendar', $scope.booking)
                    .success(function(data, status) {
                        $scope.calendarHtml = data.html;
                    });

                $('#calendarModal').modal({
                    backdrop: 'static'
                });
            }

            // open calendar modal, load actual calendar from system and re-compile them
            $scope.loadOpenCalendar = function() {

                $scope.calendarHtml = 'Loading...';

                $http.post('/api/bookings/book/opencalendar', $scope.booking)
                    .success(function(data, status) {
                        $scope.openCalendarHtml = data.html;
                    });

                $('#openCalendarModal').modal({
                    backdrop: 'static'
                });
            }

            // a date is selected in the modal
            $scope.selectDate = function(date, displayDate, session) {
                $scope.booking.date = date;
                $scope.booking.displayDate = displayDate;

                if(session) {
                    $scope.booking.session = session;
                    $scope.availableSession = session;
                }

                // disable today & fullday if the date is today
                var d = moment( displayDate );
                if(d.format('YYYY MM DD') == moment().format('YYYY MM DD') ){
                    $scope.isSameDay = true;
                    $scope.booking.session = "afternoon";
                    $scope.booking.time = "02:00PM";

                    if($scope.booking.studioSpecial)
                    {
                        $scope.booking.session = "custom";
                    }

                } else {
                    $scope.isSameDay = false;
                }

                $('#calendarModal').modal('hide');
                $('#openCalendarModal').modal('hide');
            };

            $scope.initMap = function() {

                // var myLatlng = new google.maps.LatLng(37.3000, -120.4833);
                var geocoder = new google.maps.Geocoder();
                $scope.showMap = true;
                geocoder.geocode({
                    'address': $scope.booking.address_2 + ' ' + $scope.booking.city
                }, function(results, status) {

                    if (status == google.maps.GeocoderStatus.OK) {
                        if (status != google.maps.GeocoderStatus.ZERO_RESULTS) {

                            document.getElementById('locmap-container').style.display = 'block';
                            document.getElementById('locmap').style.display = 'block';

                            if ($scope.map == false) {
                                var mapOptions = {
                                    center: results[0].geometry.location,
                                    zoom: 14,
                                    mapTypeId: google.maps.MapTypeId.ROADMAP
                                };
                                $scope.map = new google.maps.Map(document.getElementById("locmap"), mapOptions);
                            } else {
                                $scope.map.setCenter(results[0].geometry.location);
                            }
                            // map.setCenter(results[0].geometry.location);

                            // var infowindow = new google.maps.InfoWindow(
                            //     { content: '<b>hehehe</b>',
                            //       size: new google.maps.Size(150,50)
                            //     });

                            var marker = new google.maps.Marker({
                                position: results[0].geometry.location,
                                map: $scope.map,
                                title: ''
                            });

                            // Remove marker
                            marker.setMap(null);

                            // google.maps.event.addListener(marker, 'click', function() {
                            //     infowindow.open(map,marker);
                            // });
                            $scope.map.addListener('center_changed', function() {
                                $scope.booking.coordinate = $scope.map.getCenter().lat() + ',' + $scope.map.getCenter().lng();
                                // 3 seconds after the center of the map has changed, pan back to the
                                // marker.
                                // window.setTimeout(function() {
                                //map.panTo(marker.getPosition());
                                //alert("hello")
                                // }, 3000);
                            });

                        } else {
                            //alert("No results found");
                            document.getElementById('locmap-container').style.display = 'none';
                        }
                    } else {
                        //alert("Geocode was not successful for the following reason: " + status);
                        document.getElementById('locmap-container').style.display = 'none';
                    }
                });

                // navigator.geolocation.getCurrentPosition(function(pos) {
                //     map.setCenter(new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude));
                //     var myLocation = new google.maps.Marker({
                //         position: new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude),
                //         map: map,
                //         title: "My Location"
                //     });
                // });

                // $scope.map = map;
            };


            // get location and prefilled the form
            $scope.displayLocation = function(latitude, longitude) {
                var request = new XMLHttpRequest();

                var method = 'GET';
                var url = 'http://maps.googleapis.com/maps/api/geocode/json?latlng=' + latitude + ',' + longitude + '&sensor=true';
                var async = true;

                request.open(method, url, async);
                request.onreadystatechange = function() {
                    if (request.readyState == 4 && request.status == 200) {
                        var data = JSON.parse(request.responseText);
                        // alert(request.responseText); // check under which type your city is stored, later comment this line
                        var addressComponents = data.results[0].address_components;
                        // console.log(addressComponents);

                        // $scope.booking.address_2 = addressComponents.long_name
                        for (var i = 0; i < addressComponents.length; i++) {
                            var types = addressComponents[i].types

                            // street
                            if (types.indexOf("route") != -1) {
                                // console.log(addressComponents[i].long_name);
                                $scope.booking.address_2 = addressComponents[i].long_name;
                            }

                            // postal code
                            if (types.indexOf("postal_code") != -1) {
                                // console.log(addressComponents[i].long_name);
                                $scope.booking.postcode = addressComponents[i].long_name;
                            }

                            // city
                            if (types.indexOf("locality") != -1 && types.indexOf("political") != -1) {
                                // console.log(addressComponents[i].long_name);
                                $scope.booking.city = addressComponents[i].long_name;
                            }

                            // state
                            if (types.indexOf("administrative_area_level_1") != -1 && types.indexOf("political") != -1) {
                                // console.log(addressComponents[i].long_name);
                                $scope.booking.state = addressComponents[i].long_name;
                            }
                        }
                        //alert(address.city.short_name);
                    }
                };
                request.send();
            };

            $scope.successLocationCallback = function(position) {
                var x = position.coords.latitude;
                var y = position.coords.longitude;
                $scope.displayLocation(x, y);
            };

            $scope.bookingCompleted = function() {
                // console.log('bookingCompleted');
                // console.log(bookingform.address1.$invalid);
                // console.log(bookingform.address1.$pristine);

                // $('#booking-form-2').validator('validate');
                // hide booking, show payment
                $('#summaryModal').modal('hide');
                $('#waitModal').modal({
                    backdrop: 'static'
                });

                $scope.booking.name = $scope.booking.title + " " + $scope.booking.name;

                if($scope.cleaners){
                    $scope.selectCheckCleaner();

                    $scope.booking.preferred_cleaners = $scope.cleanersChecked;
                    console.log("choose previous cleaners");
                }

                $scope.booking.showCaptcha = false;

                // check rayaSpecial
                if($scope.booking.studioSpecial){
                    $scope.booking.note = 'Pakej small studio.';
                    console.log("all booking info",$scope.booking)
                }else if($scope.booking.schoolSpecial)
                {
                    $scope.booking.note = 'Pakej cuti sekolah. Tolong jaga ' + $scope.booking.kids + " orang anak.";
                }

                if($scope.booking.hours)
                {
                    $scope.booking.time = $scope.booking.hours;
                }


                //create booking and go to payment page
                $http.post('/api/bookings/book', $scope.booking)
                    .success(function(data, status) {
                        // $scope.user.verified = true;
                        

                        $timeout($scope.next, 500);
                        $scope.booking.token = data.token;

                        // Store the booking in local storage
                        window.localStorage['booking'] = JSON.stringify($scope.booking);

                        // console.log("Booking successful");
                    });
            };

            $scope.next = function() {

                // FB event
                fbq('track', 'InitiateCheckout', { 
                    content_type: 'product',
                    content_name: $scope.booking.job_type,
                    value: ($scope.booking.order_total ),
                    currency: 'MYR'
                });

                // Google Ads tracking
                <!-- Google Code for Paid Booking Conversion Page -->
                $('#google_tracker').attr('src', '//www.googleadservices.com/pagead/conversion/953758911/?value='+ $scope.booking.order_total +'&amp;currency_code=MYR&amp;label=-aGlCJ6QgGoQv-nkxgM&amp;guid=ON&amp;script=0');


                $('#waitModal').modal('hide');
                $scope.booking.showCaptcha = false;
                $location.path("/payment/" + $scope.booking.token);
                // $('#booking-start').addClass('hide');
                // $('#booking-payment').removeClass('hide');
                $('.booking-form').goTo();
            }

            if($scope.previousBooking)
            {
                $scope.showPreviousCleaners($scope.booking.mobile);

                $scope.checkReferralUsed($scope.booking.mobile);

                //check referral
            }

            $scope.package=$routeParams.package;

            if($scope.package == undefined)
            {
                
            }
            else if($routeParams.package == "weekly")
            {
                $scope.repeat($routeParams.package);
            }

            $scope.size=$routeParams.size;

            if($scope.size == undefined)
            {
                
            }
            else if($routeParams.size)
            {
                $scope.houseSize($routeParams.size);
            }

            $scope.placesResult = "";
            $scope.placesResultDetails = {}

            // watch address changes
            $scope.$watch('booking.placesResultDetails', function () {
                try {
                    console.log($scope.booking.placesResultDetails);
                    var locality = $scope.booking.placesResultDetails.adr_address.match(/<span class="locality">(.*?)<\/span>/)
                    $scope.booking.city = locality[1];
                    console.log('city',$scope.booking.city);

                    $scope.checkAvailableLocation();

                    var state = $scope.booking.placesResultDetails.adr_address.match(/<span class="region">(.*?)<\/span>/)
                    $scope.booking.state = state[1];

                    console.log('state',$scope.booking.state);

                    $scope.checkAvailableLocation();
                } catch(e) {

                }
            });

            $scope.checkCity = function(){
                if($scope.booking.city == ""){
                    $scope.error = "Please select city from dropdown";
                    return;
                }
            }

            $scope.checkAvailableLocation = function(){
                $scope.error = "";

                if( $scope.booking.city == 'Putrajaya')
                {
                    $scope.booking.state = "Selangor";
                }

                switch($scope.booking.state)
                {
                    case "Selangor":
                        break;
                    case "Negeri Sembilan":
                        break;    
                    case "Johor":
                        break;
                    case "Federal Territory of Kuala Lumpur":
                        $scope.booking.state = "Kuala Lumpur";

                        break;
                    default:
                        $scope.error = "Sorry, right now we only cover Selangor, Kuala Lumpur, Johor Bahru and Negeri Sembilan";
                        break;            
                }
            };

            $scope.otherServices = function(){
                $location.hash('service');

                $anchorScroll();
            };


            // Initialize
            // $scope.loadCities();
            // $rootScope.resizeSidebar();
        });
        }
    ])

    .run(function($rootScope) {
        $rootScope.resizeSidebar = function() {
            // $('.booking-sidebar').css('height', $('.booking-content:first').innerHeight() + 200);
        };
    })

    /******************************* Payment Controller ***********************************************/
    .controller('paymentCtrl', [
        '$scope', '$rootScope', '$route', '$document', '$window', '$routeParams', '$filter', '$location', '$http', 'BOOKING', '$timeout',
        function($scope, $rootScope, $route, $document, $window, $routeParams, $filter, $location, $http, BOOKING, $timeout) {
        angular.element(document).ready(function () {
            // var $window;
            // $window = $(window);
// , ['$timeout', function($timeout) {
            console.log('paymentCtrl()');

            $scope.token = $routeParams.token;

            // initial booking vars
            $scope.brantreeInit = false;
            $scope.booking = BOOKING.getBooking();
            $scope.payUrl = '/pay/' + $scope.booking.token;
            $scope.billplzAwaiting = false;
            $scope.paymentAwaiting = false;
            $scope.braintreeMessage = '...';
            $scope.discountMessage = null;

            $scope.amount = [];
            $scope.amount['deposit'] = '';
            $scope.amount['full'] = '';

            $scope.plzlink = [];
            $scope.plzlink['deposit'] = '';
            $scope.plzlink['full'] = '';

            // $timeout(function() {
            //   $location.path("/status/" + $scope.booking.token);
            //   $state.go($location);
            // }, 1000 * 6); //1000 * 60 * 60

            $scope.$watch('booking.token', function() {
                if ($scope.booking.repeat == 'once') {
                    $scope.payUrl = '/pay/' + $scope.booking.token;
                } else {
                    $scope.payUrl = '/subscribe/' + $scope.booking.token
                }

                // console.log($scope.payUrl);
                $scope.braintreeMessage = 'Verify this card';
                if($scope.booking.job_type != 'basic'){
                    $scope.booking.payment_amount = 'deposit';
                } else {
                    $scope.booking.payment_amount = 'full';
                }

            }, true);

            $scope.$watch('booking.payment_status', function() {
                if ($scope.booking.payment_status == 'paid') {
                    // move to next
                     
                    //if success assume booking completed clear cookies
                    
                    
                    $scope.next();
                }

            }, true);

            // switch between full and deposit amount
            // $scope.$watch('booking.payment_amount', function() {
            //     $scope.braintreeMessage = 'Verify this card';// $scope.amount[$scope.booking.payment_amount];
            //     $scope.booking.billplz_url = $scope.plzlink[$scope.booking.payment_amount];
            // }, true);

            $scope.$watch('booking.clientToken', function() {
                console.log("Initialize braintree");

                if (!$scope.booking.clientToken) {
                    return;
                }

                // avoid braintree from being initialized twice
                if ($scope.brantreeInit) {
                    return;
                }
                // briantreeClient
                $scope.briantreeClient = new braintree.api.Client({
                // Use the generated client token to instantiate the Braintree client.
                    clientToken: $scope.booking.clientToken
                });

                // activate braintree
                $scope.brantreeInit = true;
                braintree.setup($scope.booking.clientToken, "dropin", {
                    container: "payment-form",

                    paymentMethodNonceReceived: function(event, nonce) {
                        
                        // get the amount
                        var verifyAmount = 100;
                        switch ($scope.booking.job_type) {
                            case 'basic':
                            case 'ironing':
                                verifyAmount = ($scope.booking.order_total - $scope.booking.discount) * 1.00; //BOOKING.getPrice() * 1.06;
                                break;
                            case 'movein':
                                //20% deposit
                                verifyAmount = (($scope.booking.order_total - $scope.booking.discount) * 1.00 ) * 0.2;
                                break;
                        
                            case 'carpet':
                            case 'painting':
                                verifyAmount = 30;
                                break;
                            case 'spring':
                                //20% deposit
                                verifyAmount = (($scope.booking.order_total - $scope.booking.discount) * 1.00 ) * 0.2;
                                break;
                        
                        }

                        verifyAmount = +verifyAmount.toFixed(2)

                        $scope.briantreeClient.verify3DS({
													  amount: verifyAmount,
													  creditCard: nonce
													}, function (err, response) {
													  // Send response.nonce to use in your transaction
		                        $scope.booking.payment_method_nonce = response.nonce;

		                        

		                        $scope.braintreeMessage = 'PROCESSING...';
		                        $('#cardSubmit').prop('disabled', true); // disable submit button

		                        var payurl = '/api/bookings/book/pay'
		   
		                        $http.post(payurl, $scope.booking)
		                            .success(function(data, status) {
		                                // return payment_status
		                                if (data.success) {
		                                    $scope.booking.payment_status = 'paid';
		                                    $scope.next();
		                                } else {
		                                    $scope.booking.payment_status = 'failed';
		                                    $scope.braintreeMessage = 'UNSUCCESSFUL. TRY AGAIN';
		                                    $('#cardSubmit').prop('disabled', false); // enable submit button
		                                }

		                            }
		                        );

                        });
                            
                    },
                    onReady: function() {
                        console.log('Braintree is ready');
                        // $rootScope.resizeSidebar();
                        $('#cardSubmit').prop('disabled', false); // enable submit button
                    }

                });
            }, true);

            // init
            $scope.init = function() {
                console.log('after render payment');
                // return;
                // console.log($scope.token);

                // retrive booking from the server
                $http.get('/api/bookings/book/status/' + $scope.token)
                    .success(function(data, status) {

                        if (data.success) {
                            // $scope.booking = $scope.booking.concat(data.booking);

                            // console.log('Parsing...', data);

                            for (var attrname in data.booking) {
                                switch (attrname) {
                                    case 'order_total':
                                        $scope.booking.order_total = data.booking[attrname];
                                        // console.log( "order total is" + parseFloat(data.booking[attrname]));
                                        break;
                                    case 'discount':
                                        $scope.booking.discount = data.booking[attrname];
                                        // console.log( "order total is" + parseFloat(data.booking[attrname]));
                                        break;
                                    default:
                                        $scope.booking[attrname] = data.booking[attrname];
                                }
                                // console.log( data.booking[attrname] );
                            }

                            if ($scope.booking.job_type == 'airbnb' && data.user.credit) {
                                $scope.airbnb = {};
                                $scope.airbnb.credit = data.user['credit'];
                                console.log('Airbnb credit');
                                console.log($scope.airbnb.credit);
                            }

                            // console.log('Retrieved booking: ', $scope.booking);

                            // get token
                            // $scope.booking.clientToken = data.clientToken;
                            
                            if($scope.booking.showCaptcha){
                                $('#recaptchaModal').modal({
                                    backdrop: 'static'
                                });

                                grecaptcha.render('recaptcha_html_element', {
                                  'sitekey' : '6Ld9gCUTAAAAALvmYOYB1Y4aXXhxF4i9GPtekQZv',
                                  'callback' : $scope.verifyRecaptcha
                                });
                            } else {
                                $scope.getClientToken();
                            }
                        }

                    });
            }

            $scope.getClientToken = function() {
                // retrive booking from the server
                $http.get('/api/bookings/book/clientToken/' + $scope.token)
                    .success(function(data, status) {

                        

                        console.log('getClientToken()', data);

                        // credit card success
                        if (data.success) {
                            $scope.booking.clientToken = data.clientToken;
                        } else {
                            // verify mobile # again
                        }

                        // should always be successful
                        // $scope.booking.billplz_url = data.billplz_url;

                        // console.log('Billplz URL: ', $scope.booking.billplz_url);

                        // if( $scope.booking.job_type == 'carpet' || $scope.booking.job_type == 'painting')
                        //     $scope.braintreeMessage = 'PAY ' + $filter('currency')(30 , 'RM');
                        // else {

                        $scope.amount['deposit'] = 'PAY RM30.00';
                        $scope.amount['full'] = 'PAY ' + $filter('currency')($scope.booking.order_total - $scope.booking.discount , 'RM');
                        
                        $scope.plzlink['deposit'] = data.billplz_url_deposit;
                        $scope.plzlink['full'] = data.billplz_url_full;

                        // if($scope.booking.job_type == 'basic'){
                        if($scope.booking.job_type == 'basic'){
                            $scope.booking.billplz_url = $scope.plzlink['full'];
                            $scope.booking.payment_amount = 'full';
                            $scope.braintreeMessage = 'Use this card';
                        } else {
                            $scope.booking.billplz_url = $scope.plzlink['deposit'];
                            $scope.booking.payment_amount = 'deposit';
                            $scope.braintreeMessage = 'Pay '+ $filter('currency')(data.deposit_amount , 'RM') +' deposit';
                        }

                        
                        

                        if ($scope.brantreeInit) {
                            $('#cardSubmit').prop('disabled', false); // enable submit button
                        }
                    });
            }

            // verify recaptcha
            $scope.verifyRecaptcha = function(response){
                // alert(response);
                $http.post('/api/bookings/book/recaptcha', { 'response' : response } ).success(function(data, status) {
                    // alert(data);
                    if(data.success == true){
                        // alert("recaptcha ok!");
                        $('#recaptchaModal').modal('hide');
                        $scope.getClientToken();
                    }
                });
            };

            // select service
            $scope.selectPayment = function(jobType) {
                $scope.booking.payment_type = jobType;
                // console.log($scope.booking);
                return;
            };

            // Function to get the data
            $scope.getPaidAt = function() {
                $http.get('/api/bookings/book/paid/' + $scope.token)
                    .success(function(data, status) {
                        // payment is made
                        if (data.success == 1) {
                            $scope.next()
                        }
                    });
            };

            // check billplz payment
            $scope.checkPayment = function() {
                if (!$scope.billplzAwaiting) {
                    $window.open($scope.booking.billplz_url);
                }

                $scope.billplzAwaiting = true;

                // Run function every 2 seconds
                setInterval($scope.getPaidAt, 2000);
            };


            // paye with maideasy credit
            $scope.payWithCredit = function() {
                $scope.paymentAwaiting = true;
                $http.post('/api/bookings/book/deduct_credit', $scope.booking)
                    .success(function(data, status) {
                        switch (data.success) {
                            case 0:
                                $scope.discountMessage = data.message;
                                break;
                            case 1:
                                // payment successful
                                $scope.next();
                                break;
                        }
                    })
                    .finally( function() {
                        $scope.paymentAwaiting = false;
                    });
            };

            $scope.applyDiscount = function() {
                $http.post('/api/bookings/book/discount', $scope.booking)
                    .success(function(data, status) {
                        switch (data.success) {
                            case 0:
                                $scope.discountMessage = data.message;
                                break;
                            case 1:
                                switch (data.type) {
                                    case 'fixed':
                                    case 'percentage':
                                        $scope.booking.discount = data.discount;
                                        // $scope.booking.order_total = $scope.booking.order_total - data.discount;

                                        $scope.discountMessage = null;
                                        $scope.braintreeMessage = '...';
                                        $('#cardSubmit').prop('disabled', true); // disable submit button

                                        $scope.getClientToken();
                                }
                                break;
                        }
                    });

                return;
            };

            // next
            $scope.next = function() {
                // hide booking, show payment
                // $('#booking-status').removeClass('hide');
                // $('#booking-payment').addClass('hide');

                // we can assume payment successful here, track in facebook
                fbq('track', 'Purchase', { 
                    content_type: 'product',
                    content_name: $scope.booking.job_type,
                    value: $scope.booking.order_total,
                    currency: 'MYR'
                });

                //clear cookies
                document.cookie = 'referrer_code=; expires=Thu, 01 Jan 1970 00:00:01 GMT;'; 

                $location.path("/status/" + $scope.booking.token);
                $('.booking-content').goTo();
            }

        });

        }
    ])

    /******************************* Status Controller ***********************************************/
    .controller('statusCtrl', [
        '$scope', '$rootScope', '$route', '$document', '$http', '$routeParams', 'BOOKING',
        function($scope, $rootScope, $route, $document, $http, $routeParams, BOOKING) {
        angular.element(document).ready(function () {
            var $window;
            $window = $(window);
            $scope.token = $routeParams.token;

            // initial booking vars
            $scope.booking = BOOKING.getBooking();



            $scope.init = function() {
                // console.log('after render status');
                // console.log($scope.token);

                // retrive booking from the server
                $http.get('/api/bookings/book/status/' + $scope.token)
                    .success(function(data, status) {

                        console.log('Here');
                        console.log(data);
                        if (data.success) {
                            // $scope.booking = $scope.booking.concat(data.booking);
                            for (var attrname in data.booking) {
                                switch (attrname) {
                                    case 'order_total':
                                        $scope.booking.order_total = parseFloat(data.booking[attrname]);
                                        // console.log( "order total is" + parseFloat(data.booking[attrname]));
                                        break;
                                    default:
                                        $scope.booking[attrname] = data.booking[attrname];
                                }

                                // console.log( data.booking[attrname] );
                            }

                            console.log($scope.booking);

                            // get token
                            // $scope.booking.clientToken = data.clientToken;
                            // $scope.getClientToken();
                        } else {
                            // alert
                        }

                        // console.log(data);

                    });

            }
        });
        }
    ])

    /******************************* Topbar Controller ***********************************************/
    .controller('topbarCtrl', [
        '$scope', '$rootScope', '$route', '$document', 'BOOKING',
        function($scope, $rootScope, $route, $document, BOOKING) {
        angular.element(document).ready(function () {
            $scope.booking = BOOKING.getBooking();
        });
        }
    ])

    /******************************* Sidebar ***********************************************/
    .controller('sidebarCtrl', [
        '$scope', '$rootScope', '$route', '$document', 'BOOKING',
        function($scope, $rootScope, $route, $document, BOOKING) {
        angular.element(document).ready(function () {
            var $window;
            $window = $(window);

            // initial booking vars
            $scope.booking = BOOKING.getBooking();
            $scope.pricing = BOOKING.getPrice();
            $scope.user = BOOKING.getUser();
            
            // go through translation table
            $scope.trans = function(p) {
                return BOOKING.trans(p);
            }

            $scope.init = function() {

                // fix width
                $('.pricing-summary-sidebar').css('width', $('.pricing-summary-sidebar').parent().width() );
                $('.pricing-summary-sidebar').left = $('.pricing-summary-sidebar').offset().left;

                $('.pricing-summary-sidebar').affix({
                  offset: {
                    top: $('.pricing-summary-sidebar').offset().top,
                    bottom: function () {
                      return (this.bottom = $('.footer').outerHeight(true))
                    }
                  }
                }).on('affixed.bs.affix', function (e) {
                  $('.pricing-summary-sidebar').css('width', $('.pricing-summary-sidebar').parent().width() );
                });
            }

            $scope.$watch('[booking.bedroom_count,booking.bedroom_addon,booking.bathroom_addon,booking.house_size, booking.repeat, booking.job_type, booking.discount, booking.displayDate, booking.session, user.verified ,booking.bathroom_count]', function(newVal, oldVal) {
                $scope.booking.order_total = BOOKING.getPrice();
                $scope.booking.discount = BOOKING.getDiscount( $scope.booking );
                $scope.booking.deposit = BOOKING.getDeposit( $scope.booking );
                console.log("all booking data",$scope.booking)
                $('.btn').blur();
            }, true);
        });
        }
    ]);

}).call(this);

(function() {
    'use strict';
    angular.module('booking', ['ngRoute', 'ngAnimate', 'booking.controllers', 'booking.services'])
        .config([
            '$routeProvider',
            function($routeProvider) {
                var routes, setRoutes;
                // routes = ['start'];

                // setRoutes = function(route) {
                //     var config, url;
                //     url = '/' + route;
                //     config = {
                //         templateUrl: '/views/book/' + route + '.html',
                //         // controller: route + 'Ctrl'
                //     };
                //     $routeProvider.when(url, config);

                //     return $routeProvider;
                // };

                // routes.forEach(function(route) {
                //   return setRoutes(route);
                // });

                return $routeProvider.when('/', {
                    redirectTo: '/start/basic'
                }).when('/start/:session', {
                    templateUrl: '/views/book/start.html'
                }).when('/start/:session/p/:package', {
                    templateUrl: '/views/book/start.html'
                }).when('/start/:session/s/:size', {
                    templateUrl: '/views/book/start.html'
                }).when('/payment/:token', {
                    templateUrl: '/views/book/payment.html'
                }).when('/status/:token', {
                    templateUrl: '/views/book/status.html'
                }).when('/404', {
                    templateUrl: 'views/404.html'
                }).otherwise({
                    redirectTo: '/404'
                });

            }
        ])

    .directive('afterRender', ['$timeout', function($timeout) {
        var def = {
            restrict: 'A',
            link: function(scope, element, attrs) {
                // console.log(attrs.afterRender);
                $timeout(scope.$eval(attrs.afterRender), 0); //Calling a scoped method
            }
        };
        return def;
    }])

    .directive('pluralize', function() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, ngModel) {

                //format text going to user (model to view)
                ngModel.$formatters.push(function(value) {
                    return value.toUpperCase();
                });

                //format text from the user (view to model)
                ngModel.$parsers.push(function(value) {
                    return value.toLowerCase();
                });
            }
        }
    })

    .directive('dynamic', function($compile) {
        return {
            restrict: 'A',
            replace: true,
            link: function(scope, ele, attrs) {
                scope.$watch(attrs.dynamic, function(html) {
                    ele.html(html);
                    $compile(ele.contents())(scope);
                });
            }
        };
    })

    .directive('starRating', function() {
        return {
            restrict: 'A',
            template: '<p class="text-success profile-rating">' +
                '<i ng-repeat="star in stars" class="fa" ng-class="star">' +
                '</i>' +
                '</p>',
            scope: {
                ratingValue: '=',
                max: '='
            },
            link: function(scope, elem, attrs) {
                scope.stars = [];
                for (var i = 0; i < scope.max; i++) {
                    if (i < scope.ratingValue) {
                        scope.stars.push({
                            'fa-star': true
                        });
                    } else {
                        scope.stars.push({
                            'fa-star-o': true
                        });
                    }
                }
            }
        }
    });

    ;

}).call(this);

(function($) {
    $.fn.goTo = function() {
        $('html, body').animate({
            scrollTop: $(this).offset().top + 'px'
        }, 'fast');
        return this; // for chaining...
    }
})(jQuery);

//# sourceMappingURL=booking.js.map
